import { SideBarContent } from "./";
import { SideBarDrawer} from "../drawer";
const SideBar = () => {
  return (
    <>
      <SideBarContent />
      <SideBarDrawer />
    </>
  );
};
export default SideBar;
